import script from "./drillTable.vue?vue&type=script&setup=true&lang=js"
export * from "./drillTable.vue?vue&type=script&setup=true&lang=js"

import "./drillTable.vue?vue&type=style&index=0&id=61c41123&lang=scss"

const __exports__ = script;

export default __exports__